const state = () => {
  return {
    darkMode: false,
    loading: false,
    breadCrumbs: [],
    productStatus: undefined,
    otpResetPassword: undefined,
    otpResetPasswordSuccess: undefined,
    accountActivate: undefined,
    quotationCreated: undefined,
    bellMessages: []
  }
}

/// getters
const getters = {
  darkMode: (actualState) => actualState.darkMode,
  loading: (actualState) => actualState.loading,
  breadCrumbs: (actualState) => actualState.breadCrumbs,
  products: (actualState) => actualState.products,
  urlOriginIsBrandIn() {
    const currentHost = (window.location?.host || '').replace(/^www\./, '')
    const brandInDomain = (process.env.VUE_APP_BRAND_IN_DOMAIN || '').replace(
      /^www\./,
      ''
    )
    return currentHost === brandInDomain
  }
}

// actions
const actions = {
  setDarkMode({ commit }, darkMode) {
    commit('setToDarkMode', { darkMode })
  }
}

// mutations
const mutations = {
  setToDarkMode(actualState, { darkMode }) {
    actualState.darkMode = darkMode
  },
  setShowSpinner(actualState, spinnerShow) {
    actualState.loading = spinnerShow
  },
  setBreadCrumbs(actualState, breadCrumbs) {
    actualState.breadCrumbs = breadCrumbs
  },
  setProductStatus(actualState, productStatus) {
    actualState.productStatus = productStatus
  },
  setOtpResetPassword(actualState, otpResetPassword) {
    actualState.otpResetPassword = otpResetPassword
  },
  setOtpResetPasswordSuccess(actualState, otpResetPasswordSuccess) {
    actualState.otpResetPasswordSuccess = otpResetPasswordSuccess
  },
  setAccountActivate(actualState, accountActivate) {
    actualState.accountActivate = accountActivate
  },
  setQuotationCreated(actualState, quotationCreated) {
    actualState.quotationCreated = quotationCreated
  },
  setBellMessages(actualState, bellMessages) {
    actualState.bellMessages = bellMessages
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
